export default __webpack_public_path__ + "static/media/icon-stoom-points.0418046f.png";